import { cva } from 'class-variance-authority';

export const iconVariants = cva(
  'flex items-center justify-center [&>svg]:fill-current',
  {
    variants: {
      size: {
        tiny: [
          '[&>svg]:w-sizing-comp-button-icon-tiny-icon',
          '[&>svg]:h-sizing-comp-button-icon-tiny-icon',
        ],
        small: [
          '[&>svg]:w-sizing-comp-button-icon-small-icon',
          '[&>svg]:h-sizing-comp-button-icon-small-icon',
        ],
        medium: [
          '[&>svg]:w-sizing-comp-button-icon-medium-icon',
          '[&>svg]:h-sizing-comp-button-icon-medium-icon',
        ],
      },
      loading: { true: 'invisible', false: '' },
    },
  },
);
